"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _StyledLabel = _interopRequireDefault(require("../StyledLabel"));

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ActionFilter = function ActionFilter(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'primary' : _ref$kind,
      text = _ref.text,
      count = _ref.count,
      StartIcon = _ref.startIcon,
      EndIcon = _ref.endIcon;
  var buttonText = count ? "".concat(text, " ").concat(count) : text;
  return _react.default.createElement(_react.default.Fragment, null, StartIcon && _react.default.createElement(_.Flex, {
    paddingRight: 0.5
  }, _react.default.createElement(StartIcon, {
    size: "small",
    role: "img"
  })), _react.default.createElement(_StyledLabel.default, {
    kind: kind,
    active: active
  }, buttonText), EndIcon && _react.default.createElement(_.Flex, {
    paddingLeft: 0.5
  }, _react.default.createElement(EndIcon, {
    size: "small",
    role: "img"
  })));
};

var _default = ActionFilter;
exports.default = _default;